import Helpers from '../lib/Helpers'
import Component from '../inherited/Component'

export default class CountdownTimer extends Component {
  constructor (elem, theme, options, ctx) {
        super(elem, theme, options, ctx)
        this._elem = elem
        this._options = {...{
            epoch: 0,
            separator: '<span class="countdown-separator">:</span>'
        }, ...this._options}
        this._timer = null
        this._timerElems = this._elem.querySelectorAll('[data-time]')
    }

    async  mount () {
        let Countdown = await require('countdown-js')

        this._timer = Countdown.timer(new Date(this._options.epoch * 1000), (timeLeft) => {
            this._updateTimeElems(timeLeft)
        }, () => {
            this._updateTimeElems({
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            }, false)
        })
    }

    _updateTimeElems (timeLeft, reachedZero = true) {
        let marqueeBar
        function hasSomeParentTheClass(element, classname) {
            if (element.className) {
                if (element.className.split(' ').indexOf(classname)>=0) {
                    marqueeBar = element
                    return true
                }
            }
            return element.parentNode && hasSomeParentTheClass(element.parentNode, classname)
        }

        for (let [index, timeElem] of this._timerElems.entries()) {
            let time = timeLeft[timeElem.dataset.time]
            if (time === 0 && reachedZero) {
                timeElem.classList.add('hide')
            } else {
                reachedZero = false

                if(hasSomeParentTheClass(timeElem, 'marquee-bar')) {
                    let dataAttr = timeElem.dataset.time
                    for (let element of marqueeBar.querySelectorAll('[data-time="'+ dataAttr +'"]')) {
                        element.innerHTML = Helpers.pad(time, 2)
                        
                        if (!this._options.numbersOnly) {
                            if (element.dataset.time === 'days') {
                                element.innerHTML += 'd'
                            }

                            if (element.dataset.time === 'hours') {
                                element.innerHTML += 'h'
                            }

                            if (element.dataset.time === 'minutes') {
                                element.innerHTML += 'm'
                            }

                            if (element.dataset.time === 'seconds') {
                                element.innerHTML += 's'
                            }
                        }
                    
                        if ((index + 1) !== this._timerElems.length) {
                            element.innerHTML += this._options.separator
                        }
                    }

                } else {
                    timeElem.innerHTML = Helpers.pad(time, 2)

                    if ((index + 1) !== this._timerElems.length) {
                        timeElem.innerHTML += this._options.separator
                    }

                    if (!this._options.numbersOnly) {
                        if (timeElem.dataset.time === 'days') {
                            timeElem.innerHTML += '<span class="countdown-term">Days</span>'
                        }

                        if (timeElem.dataset.time === 'hours') {
                            timeElem.innerHTML += '<span class="countdown-term">Hours</span>'
                        }

                        if (timeElem.dataset.time === 'minutes') {
                            timeElem.innerHTML += '<span class="countdown-term">Mins</span>'
                        }

                        if (timeElem.dataset.time === 'seconds') {
                            timeElem.innerHTML += '<span class="countdown-term">Secs</span>'
                        }
                    }
                }

            }
        }
    }

    
}
